import posthog from 'posthog-js';

export function usePostHog () {
    posthog.init('phc_kNu0hliAM0nkEIPm6bopA8HCEcsM2Wc2QPpqfu2mrgM', {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-05-24',
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    });

   
    return { posthog };
}
